import { render } from "./horizontal.vue?vue&type=template&id=f3525928&scoped=true&ts=true"
import script from "./horizontal.vue?vue&type=script&lang=ts"
export * from "./horizontal.vue?vue&type=script&lang=ts"

import "./horizontal.vue?vue&type=style&index=0&id=f3525928&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3525928"]])

export default __exports__